module.exports = __webpack_public_path__ + "static/media/Middle_First_Building_Dark.fb8fcf67.png";